import React from 'react';
import { func, string, number } from 'prop-types';
import { IconContainer, TextContainer, Text, Span, PinIcon } from './zipcode-text.styles';
import { locationText } from '../../utils';

const ZipcodeText = ({
  city,
  defaultText,
  formatter,
  iconHeight,
  iconWidth,
  state,
  text,
  zipcode
}) => {
  const textLocation = locationText({
    formatter,
    zipCode: zipcode,
    zipCodeCity: city,
    zipCodeState: state,
    includeAddress: false
  });
  return /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(PinIcon, {
    width: iconWidth,
    height: iconHeight
  })), /*#__PURE__*/React.createElement(Text, {
    "data-testid": "text-line"
  }, zipcode && state && city ? /*#__PURE__*/React.createElement(React.Fragment, null, text, " ", formatter ? /*#__PURE__*/React.createElement(Span, null, textLocation) : textLocation) : defaultText));
};

ZipcodeText.defaultProps = {
  city: undefined,
  formatter: undefined,
  iconHeight: undefined,
  iconWidth: undefined,
  state: undefined,
  zipcode: undefined
};
process.env.NODE_ENV !== "production" ? ZipcodeText.propTypes = {
  city: string,
  formatter: func,
  defaultText: string.isRequired,
  iconHeight: number,
  iconWidth: number,
  state: string,
  text: string.isRequired,
  zipcode: string
} : void 0;
export default ZipcodeText;